export default __webpack_public_path__ + "static/media/ms.c6877684.svg";